<div class="lvi-content">
    <div class="avatar">
        <i class="nio icon-frais"></i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="consultAbattement()">{{ data.getLibelleHoraireAffichage() }}</a>
        </div>
        <ul class="lvi-attrs">
            <li><strong>{{ 'admin.frais.indemnites.abattements.detail.generalites.regleAttribution' | translate }}</strong> {{ data.getLibelleHoraireAffichage() }}</li>
            <li><strong>{{ 'admin.frais.indemnites.abattements.detail.generalites.typeEntite' | translate }}</strong> {{ data.getLibelleTypeEntiteAffichage() }}</li>
            <li><strong>{{ 'admin.frais.indemnites.abattements.detail.generalites.nbJours' | translate }}</strong> {{ data.nbJours }}</li>
            <li><strong>{{ 'admin.frais.indemnites.abattements.detail.generalites.abattement' | translate }}</strong> {{ data.pourcentageAbattement | number:'1.0-2' }} %</li>
        </ul>
    </div>
    <div class="lvi-actions">
        <button mat-icon-button (click)="deleteAbattement()" [matTooltip]="'global.actions.supprimer' | translate">
            <i class="nio icon-suppression"></i>
        </button>
    </div>
</div>
